// extracted by mini-css-extract-plugin
module.exports = {"mainImage":"styles_mainImage__2qhqZ","logo":"styles_logo__XIp4h"};